<script module lang="ts">
  const FINDING_PROVIDERS = ["sharepoint", "google drive"];

  const findingProviderValue: Record<string, string> = {
    sharepoint: "msgraph-v4",
    "google drive": "google-drive-v1.0.0",
  };

  export type FindingProvider = (typeof FINDING_PROVIDERS)[number];
</script>

<script lang="ts">
  import { toTitleCase } from "$lib/utils/text";
  import * as Select from "$ui/select";

  export const {
    selectAll = false,
    readonlyStatuses,
    onChange,
    value,
    placeholder,
    sameWidth = true,
    disabled = false,
  }: {
    selectAll?: boolean;
    placeholder?: string;
    value?: FindingProvider;
    sameWidth?: boolean;
    readonlyStatuses: FindingProvider[];
    onChange?: (status: FindingProvider | null) => void;
    disabled?: boolean;
  } = $props();
  let findingProviders =
    readonlyStatuses && readonlyStatuses.length > 0
      ? FINDING_PROVIDERS.filter((s) => !readonlyStatuses.includes(s))
      : FINDING_PROVIDERS;
</script>

<div class="min-w-[8rem]">
  <Select.Root
    onSelectedChange={(selectedStatus) => {
      if (selectAll && selectedStatus?.value === "all") {
        onChange && onChange(null);
      } else {
        onChange && onChange(selectedStatus?.value as FindingProvider);
      }
    }}
    {disabled}
  >
    <Select.Trigger name="alias">
      <Select.Value placeholder={toTitleCase(value || placeholder || "No Status")} />
    </Select.Trigger>
    <Select.Content {sameWidth}>
      <Select.Group>
        {#if selectAll}
          <Select.Item value="all" label={placeholder} isSelected={!value}>
            {placeholder}
          </Select.Item>
        {/if}
        {#each findingProviders as findingProvider}
          <Select.Item
            value={findingProviderValue[findingProvider]}
            label={toTitleCase(findingProvider)}
            isSelected={findingProvider === value}
          >
            {toTitleCase(findingProvider)}
          </Select.Item>
        {/each}
      </Select.Group>
    </Select.Content>
  </Select.Root>
</div>
